'use strict';exports.__esModule = true;exports.realtorPackages = exports.getFormattedRealtorPackagePeriods = exports.realtorPackagePeriods = exports.getAdsCountValues = exports.PACKAGES_DESCRIPTION = exports.PACKAGE_PERIODS = exports.PACKAGE_FEATURES_ORDER = exports.PACKAGE_FEATURES = exports.PROMOTIONS = exports.PACKAGE_PERIODS_TITLE = exports.PACKAGE_PERIODS_NAMES = exports.REALTOR_PACKAGE_ID_PREFIX = undefined;var _PACKAGE_PERIODS, _, _2, _3, _4;var _Package = require('./Package');var _Package2 = _interopRequireDefault(_Package);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var REALTOR_PACKAGE_ID_PREFIX = exports.REALTOR_PACKAGE_ID_PREFIX = 'realtors_package_id_';

var PACKAGE_PERIODS_NAMES = exports.PACKAGE_PERIODS_NAMES = {
  TWENTY_ONE_DAYS: 'TWENTY_ONE_DAYS',
  MONTH: 'MONTH',
  TREE_MONTHS: 'TREE_MONTHS',
  YEAR: 'YEAR' };


var PACKAGE_PERIODS_TITLE = exports.PACKAGE_PERIODS_TITLE = [
'regular',
'advanced',
'upgraded',
'premium'];


var PROMOTIONS = exports.PROMOTIONS = {
  PROPERTIES: 'properties',
  HIGHLIGHTS: 'highlight',
  AUTO_JUMPS: 'autojump',
  TOP_AD: 'top_promotion' };


var PACKAGE_FEATURES = exports.PACKAGE_FEATURES = {
  PROPERTIES: PROMOTIONS.PROPERTIES,
  UNLIMITED_AGENTS: 'unlimited_agents',
  VIRTUAL_NUMBERS: 'virtual_numbers',
  COMPANY_PAGE: 'page',
  HIGHLIGHTS: PROMOTIONS.HIGHLIGHTS,
  AUTO_JUMPS: PROMOTIONS.AUTO_JUMPS,
  TOP_AD: PROMOTIONS.TOP_AD };


var PACKAGE_FEATURES_ORDER = exports.PACKAGE_FEATURES_ORDER = [
PACKAGE_FEATURES.PROPERTIES,
PACKAGE_FEATURES.UNLIMITED_AGENTS,
PACKAGE_FEATURES.VIRTUAL_NUMBERS,
PACKAGE_FEATURES.COMPANY_PAGE,
PACKAGE_FEATURES.HIGHLIGHTS,
PACKAGE_FEATURES.AUTO_JUMPS,
PACKAGE_FEATURES.TOP_AD];


var PACKAGE_PERIODS = exports.PACKAGE_PERIODS = (_PACKAGE_PERIODS = {}, _PACKAGE_PERIODS[
PACKAGE_PERIODS_NAMES.TWENTY_ONE_DAYS] = {
  periodName: PACKAGE_PERIODS_NAMES.TWENTY_ONE_DAYS,
  value: 21,
  label: 'treeWeeks',
  multiplier: 1 }, _PACKAGE_PERIODS[

PACKAGE_PERIODS_NAMES.MONTH] = {
  periodName: PACKAGE_PERIODS_NAMES.MONTH,
  value: 30,
  label: 'month',
  multiplier: 1 }, _PACKAGE_PERIODS[

PACKAGE_PERIODS_NAMES.TREE_MONTHS] = {
  periodName: PACKAGE_PERIODS_NAMES.TREE_MONTHS,
  value: 90,
  label: 'threeMonth',
  multiplier: 3 }, _PACKAGE_PERIODS[

PACKAGE_PERIODS_NAMES.YEAR] = {
  periodName: PACKAGE_PERIODS_NAMES.YEAR,
  value: 365,
  label: 'year',
  multiplier: 12 }, _PACKAGE_PERIODS);



var buildPackageFeatures = function buildPackageFeatures(
adsQuantity,
unlimitedAgents,
virtualNumbers,
companyPage,
highlightsQuantity,
autojumpsQuantity,
topPromotionQuantity) {var _ref;return _ref = {}, _ref[

  PACKAGE_FEATURES.PROPERTIES] = adsQuantity, _ref[
  PACKAGE_FEATURES.UNLIMITED_AGENTS] = unlimitedAgents, _ref[
  PACKAGE_FEATURES.VIRTUAL_NUMBERS] = virtualNumbers, _ref[
  PACKAGE_FEATURES.COMPANY_PAGE] = companyPage, _ref[
  PACKAGE_FEATURES.HIGHLIGHTS] = highlightsQuantity, _ref[
  PACKAGE_FEATURES.AUTO_JUMPS] = autojumpsQuantity, _ref[
  PACKAGE_FEATURES.TOP_AD] = topPromotionQuantity, _ref;};


var PACKAGES_DESCRIPTION = exports.PACKAGES_DESCRIPTION = {
  10: (_ = {}, _[
  PACKAGE_PERIODS_NAMES.MONTH] = {
    priceForAdPerMonth: 24.9,
    features: buildPackageFeatures(
    10,
    true,
    true,
    false,
    0,
    0,
    0) }, _[


  PACKAGE_PERIODS_NAMES.YEAR] = {
    priceForAdPerMonth: 19.9,
    oldPriceForAdPerMonth: 24.9,
    features: buildPackageFeatures(
    10,
    true,
    true,
    true,
    0,
    0,
    0) }, _),



  25: (_2 = {}, _2[
  PACKAGE_PERIODS_NAMES.MONTH] = {
    priceForAdPerMonth: 17.96,
    features: buildPackageFeatures(
    25,
    true,
    true,
    false,
    0,
    0,
    0) }, _2[


  PACKAGE_PERIODS_NAMES.YEAR] = {
    priceForAdPerMonth: 14.36,
    oldPriceForAdPerMonth: 17.96,
    features: buildPackageFeatures(
    25,
    true,
    true,
    true,
    1,
    0,
    0) }, _2),



  50: (_3 = {}, _3[
  PACKAGE_PERIODS_NAMES.MONTH] = {
    priceForAdPerMonth: 13.98,
    features: buildPackageFeatures(
    50,
    true,
    true,
    false,
    1,
    2,
    0) }, _3[


  PACKAGE_PERIODS_NAMES.YEAR] = {
    priceForAdPerMonth: 11.18,
    oldPriceForAdPerMonth: 13.98,
    features: buildPackageFeatures(
    50,
    true,
    true,
    true,
    2,
    5,
    0) }, _3),



  100: (_4 = {}, _4[
  PACKAGE_PERIODS_NAMES.MONTH] = {
    priceForAdPerMonth: 11.99,
    features: buildPackageFeatures(
    100,
    true,
    true,
    false,
    2,
    3,
    0) }, _4[


  PACKAGE_PERIODS_NAMES.YEAR] = {
    priceForAdPerMonth: 9.59,
    oldPriceForAdPerMonth: 11.99,
    features: buildPackageFeatures(
    100,
    true,
    true,
    true,
    5,
    10,
    1) }, _4) };





var POSSIBLE_ADS_COUNT = ['10', '25', '50', '100'];

var getAdsCountValues = exports.getAdsCountValues = POSSIBLE_ADS_COUNT.map(function (it) {return { value: it, label: it };});

var realtorPackagePeriods = exports.realtorPackagePeriods = [PACKAGE_PERIODS.MONTH, PACKAGE_PERIODS.YEAR];

var getFormattedRealtorPackagePeriods = exports.getFormattedRealtorPackagePeriods = function getFormattedRealtorPackagePeriods(translate) {return realtorPackagePeriods.
  map(function (_ref2) {var value = _ref2.value,label = _ref2.label;return { value: value, label: translate(label + 'ly') };});};

var buildPackage = function buildPackage(index, id, properties, period) {return {
    index: index,
    id: id,
    properties: properties,
    period: period };};


var possiblePackages = [
buildPackage(0, 'primary_1', 10),
buildPackage(1, 'primary_2', 25),
buildPackage(2, 'primary_3', 50),
buildPackage(3, 'primary_4', 100)];


var realtorPackages = exports.realtorPackages = possiblePackages.map(function (item) {return new _Package2.default(item);});


//////////////////
// WEBPACK FOOTER
// ./src/containers/RealtorPackagesContainer/packagesConfigs.js
// module id = 197
// module chunks = 0